/** `/api/v2/patients` – Liste, Anlegen, Löschen, Abfragen, Export. */
import { API_BASE, http, httpBlob } from './http'
import type {
  CreatePatientRequest,
  DailyCount,
  DownloadedFile,
  EntriesParams,
  ExportFormat,
  LogEntry,
  Paginated,
  Patient,
} from './types'

export function listPatients(): Promise<Patient[]> {
  return http.get<Patient[]>('/patients')
}

export function createPatient(payload: CreatePatientRequest): Promise<Patient> {
  return http.post<Patient>('/patients', payload)
}

export function getPatient(id: number): Promise<Patient> {
  return http.get<Patient>(`/patients/${id}`)
}

export function removePatient(id: number): Promise<void> {
  return http.delete<void>(`/patients/${id}`)
}

export function getEntries(id: number, params: EntriesParams = {}): Promise<Paginated<LogEntry>> {
  return http.get<Paginated<LogEntry>>(`/patients/${id}/entries`, {
    query: {
      page: params.page,
      page_size: params.page_size,
      from: params.from,
      to: params.to,
      sort: params.sort,
    },
  })
}

export function getDailyCounts(id: number): Promise<DailyCount[]> {
  return http.get<DailyCount[]>(`/patients/${id}/entries/daily`)
}

/** URL des servergerenderten QR-PNGs (direkt als `<img src>` verwendbar). */
export function qrImageUrl(id: number): string {
  return `${API_BASE}/patients/${id}/qr.png`
}

/** Lädt den Export als Blob inkl. Dateiname aus `Content-Disposition`. */
export function exportFile(id: number, format: ExportFormat = 'xlsx'): Promise<DownloadedFile> {
  return httpBlob(`/patients/${id}/export`, { query: { format } }, `patient-${id}.${format}`)
}

export const patientsApi = {
  listPatients,
  createPatient,
  getPatient,
  removePatient,
  getEntries,
  getDailyCounts,
  qrImageUrl,
  exportFile,
}
